import React from 'react';
const svgText = ({ color1, color2, text,index }) => {
    let w = 160
    let h = 80
    let fontSize = 60
  return (
    <svg width={w} height={h}>
      <defs>
        <linearGradient id={"gradient"+index} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color={color1} />
          <stop offset="100%" stop-color={color2} />
        </linearGradient>
      </defs>
      <text x={w/2} y={h/2+fontSize/3} fontSize={fontSize} fontWeight="bold" fill={`url(#gradient${index})`} textAnchor="middle" 
                dominantBaseline="middle" >
        {text}
      </text>
    </svg>
  );
};

export default svgText;
